// extracted by css-extract-rspack-plugin
export default {"clearAction":"xLk5mlKIUCJ4Ts1w","clearActionButton":"kcczrO8FFZIinRyS","clearActionLabel":"jJIctJuqlgE52U6l"};